import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "matching-question-container"
};
const _hoisted_2 = {
  class: "question-preamble"
};
const _hoisted_3 = {
  class: "items-matching"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_items_matching = _resolveComponent("items-matching");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('chapter.question.matching.title')), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_items_matching, {
    pairs: _ctx.matchingPairs,
    onPairsUpdate: _ctx.onPairsUpdate
  }, null, 8, ["pairs", "onPairsUpdate"])]), _createElementVNode("span", {
    class: "add-pair-btn",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.addPair())
  }, [_cache[1] || (_cache[1] = _createTextVNode(" + ", -1)), _createElementVNode("u", null, _toDisplayString(_ctx.$t('chapter.question.matching.addPair')), 1)])]);
}